import { Box, Typography } from '@mui/material'



export default function FeatureCard({ ...props }) {
  const { imgSrc, title, descipt } = props

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      <Box>
        <img
          src={imgSrc}
          alt={title}
          style={{ width: '60%', margin: 'auto' }}
        />
      </Box>
      <Typography variant="h5" >{title}</Typography>
      <Box>
        {descipt.map((item, i) => (
          <Typography
            variant="body1"
            key={i}
            align="justify"
            style={{ textIndent: '-1em', marginBottom: '0.5rem' }}
          >
            ╴{item}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}
